<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="isLoadingMap.table === true"
      class="elevation-1"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-center">
            <avatar
              :firstname="item.objectKey"
              :size="35"
              :font="14"
            />
          </td>
          <td>
            {{ `${item.objectKey}`.trim() }} <br>
            <span class="caption grey--text">{{ item.role }}</span>
          </td>
          <td>
            {{ `${item.size}` }}
          </td>
          <td>
            rvt
          </td>
          <td>
            <v-chip
              small
              outlined
              rounded
              :color="modelStatus(item, 'color')"
            >
              {{ modelStatus(item, 'label') }}
            </v-chip>
          </td>
          <td class="text-center">
            <v-progress-circular
              v-if="isLoadingMap[item.id] === true"
              :size="20"
              :width="2"
              color="primary"
              indeterminate
            />
            <v-menu
              v-if="isLoadingMap[item.id] !== true"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  v-if="item.joined !== true"
                  @click.stop="convertModel(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        left
                        small
                      >
                        slideshow
                      </v-icon>
                      View   Model
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Avatar from "../Avatar"
import UserDeleteDialog from "./UserDeleteDialog"

export default {
  components: { UserDeleteDialog, Avatar },
  computed: {
    ...mapGetters([ 'undeletedUsers' ]),
    items() {
      return this.undeletedUsers
    }
  },
  methods: {
    ...mapActions([ 'inviteTenantUser', 'fetchFixtureList','convertFileSVF']),
    modelStatus(user, key) {
      const map = {
        JOINED: {
          color: 'green',
          label: 'Viewable'
        },
        INVITED: {
          color: 'warning',
          label: 'Corupted'
        },
        NOT_INVITED: {
          color: 'green',
          label: 'Viewable'
        }
      }

      if (user.joined === true) {
        return map.JOINED[ key ]
      }
      if (user.invited === true) {
        return map.INVITED[ key ]
      }

      return map.NOT_INVITED[ key ]
    },
    setIsLoadingMap(id, value) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [ id ]: !!value
      }
    },
    async convertModel (item) {
      const payload = { ...item}
      this.setIsLoadingMap('table', true)
      const convert = await this.convertFileSVF(payload)
        .then(res => {
          console.log(res)
          this.$router.push({ name: 'model-viewer', params: { urn: res.data.convert.urn, token: res.data.token._fieldsProto.access_token.stringValue, id: this.$route.params.id }})
          })
        .finally(() => { this.setIsLoadingMap('table', false) })

      this.convert = [ ...convert ]
    },
    async loadTable() {
      const payload ={
        projectId: this.$route.params.id
      }
      console.log(this.$route.params)
      this.setIsLoadingMap('table', true)
      const list = await this.fetchFixtureList(this.$route.params.cat)
        .then(res => res)
        .finally(() => { this.setIsLoadingMap('table', false) })

      this.list = [ ...list ]
    }
  },
  mounted() {
    console.log('mounted')
    this.loadTable()
  },
  data() {
    return {
      isLoadingMap: {},
      list: [],
      headers: [
        {
          text: '',
        },
        {
          text: 'Name',
        },
        {
          text: 'Size',
        },
        {
          text: 'Type',
        },
        {
          text: 'Status'
        },
        {
          text: 'Actions',
          align: 'right'
        }

      ]
    }
  }
}
</script>
